/* eslint-disable no-param-reassign */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import style from './Review.module.scss';
import { clickTracker, getRatingImages, CheckingValidComment } from '../../lib/common';
import { getCsRatings, updateCsRatings } from '../../api/ratings';
import useAlert from '../../hooks/useAlert';
import { useAppState } from '../../contexts/appState';
import ConfirmationDialog from '../../components/Popups/ConfirmationDialog';

const CSratings = () => {
  const [score, setScore] = useState(0);
  const [ratingColor, setRatingColor] = useState();
  const [image, setImage] = useState(getRatingImages.TAP_TO_RATE);
  const [imageText, setImageText] = useState();
  const [activeIndex, setActiveIndex] = useState({});
  const [comment, setComment] = useState('');
  const [reviewType, setReviewType] = useState();
  const [team, setTeam] = useState();
  const [setAlert] = useAlert();
  const [results, setResults] = useState();
  const queryParams = new URLSearchParams(window.location.search);
  const shortId = queryParams.get('shortId');
  const [warningText, setWarningText] = useState(false);
  const [appState] = useAppState();
  const { popupObj } = appState;

  const dsatFlag = queryParams.get('dsat');

  const aflag = dsatFlag ? 'dsat' : 'csat';
  const feedbackType = {
    csat: {
      pageHeading: 'How would you rate your experience?',
      tagHeading: '',
      reviewHeading: 'Tell us about your experience',
    },
    dsat: {
      pageHeading: 'You Rated Us ',
      tagHeading: 'What Went Wrong?',
      reviewHeading: 'How could we improve?',
    },
  };

  const QuestionMap = {
    '1,2': 'What went wrong?',
    '3,4,5': 'What was not upto Mark?',
    '6,7,8': 'What did you like?',
    '9,10': ' What went well?',
  };

  const source = queryParams.get('utm_source');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const color = [
    {
      num: '1,2',
      color: 'VeryBad',
      image: getRatingImages.BAD,
      backgroundColor: '#ec4f4f',
    },
    {
      num: '3,4',
      color: 'Bad',
      image: getRatingImages.BAD,
      backgroundColor: '#fc6e01',
    },
    {
      num: '5',
      color: 'Average',
      image: getRatingImages.AVERAGE,
      backgroundColor: '#fc6e01',
    },
    {
      num: '6,7,8',
      color: 'Good',
      image: getRatingImages.GOOD,
      backgroundColor: '#34b225',
    },
    {
      num: '9,10',
      color: 'Excellent',
      image: getRatingImages.EXCELLENT,
      backgroundColor: '#228105',
    },
  ];
  const enableSubmitButton = CheckingValidComment(comment);

  const [tags, setTags] = useState([]);

  const handleTags = async (index, tagId) => {
    await clickTracker(`${aflag}tag_${tagId}`, aflag);
    setActiveIndex((prevActiveButtons) => ({
      ...prevActiveButtons,
      [index]: !prevActiveButtons[index],
    }));
    const updateTagStatus = tags;
    updateTagStatus.forEach((tag) => {
      if (tag.id === tagId) {
        tag.selected = !tag.selected;
      }
    });
    setTags([...updateTagStatus]);
  };

  const handleFeedbackEnable = () => {
    let tagsExist = false;
    tags.forEach((tag) => {
      if (tag.selected) {
        tagsExist = true;
      }
    });

    if (dsatFlag === '1' && (tagsExist || (comment.length > 0 && enableSubmitButton))) {
      return true;
    }
    return false;
  };

  const filterTags = async (star) => {
    try {
      let filteredTags = [];
      filteredTags = results.tags.filter((tag) => {
        return tag.star?.split(',')?.includes(star.toString());
      });
      setTags(filteredTags);
    } catch (err) {
      console.log('Err in filterTags', err);
    }
  };

  const submitFeedBack = async () => {
    await clickTracker(`${aflag}description`, aflag);
    await clickTracker(`${aflag}_submit`, aflag);
    if (comment.length === 0 || comment.length > 3) {
      const tagsIdList = [];
      tags.map((t) => {
        if (t.selected === true) {
          tagsIdList.push(t.id);
        }
        return null;
      });
      const params = {
        shortId,
        rating: score,
        rev: comment,
        tags: tagsIdList,
        source,
        team,
        reviewType,
        dsatFlag: dsatFlag === '1',
      };
      const response = await updateCsRatings(params);
      if (response.errorCode && response.errorCode !== 0) {
        setAlert({
          message: 'Something went wrong!',
          status: false,
        });
      }
      navigate('/ratings/success?key=0');
    }
  };

  const getData = async () => {
    try {
      const params = {
        shortId,
      };
      setLoading(true);

      const res = await getCsRatings(params);
      if (res.rating !== 0 && !dsatFlag) {
        navigate(`/ratings/success?key=3`);
      }
      setLoading(false);
      setResults(res);
      setReviewType(res.reviewType);
      setTeam(res.team);
    } catch (err) {
      navigate(`/ratings/success?key=1`);
    }
  };

  const handleRatingClick = async (ele, num) => {
    if (dsatFlag !== '1') {
      await clickTracker(`${aflag}scale_${ele.num}`, aflag);
      setScore(parseInt(num, 10));
      setRatingColor(style[ele.color]);
      setImage(ele.image);
      filterTags(parseInt(num, 10));
    } else {
      setWarningText(true);
      setTimeout(() => {
        setWarningText(false);
      }, 3000);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handleQuestions = () => {
    let question = '';
    if (score) {
      Object.entries(QuestionMap).forEach((ele) => {
        if (ele[0].split(',').includes(score.toString())) {
          [, question] = ele;
        }
      });
    }
    return question;
  };

  useEffect(() => {
    if (dsatFlag === '1' && results?.rating && results?.rating !== 0) {
      filterTags(results.rating.toString());
      const selectedRatingColor = color.filter((ele) => ele.num.split(',').includes(results.rating.toString()));
      setRatingColor(style[selectedRatingColor[0]?.color]);
      setScore(results.rating);
    }
  }, [results]);

  const handleOnChange = (e) => {
    setComment(e.target.value);
  };
  useEffect(() => {
    if (!score) {
      setImageText('Tap to Rate');
    } else if (score < '3') setImageText('Very Bad');
    else if (score > '2' && score < '5') setImageText('Bad');
    else if (score > '4' && score < '6') setImageText('Average');
    else if (score > '5' && score < '9') setImageText('Good');
    else if (score > '8') setImageText('Excellent');
  }, [score]);

  useEffect(() => {
    getData();
  }, []);
  useEffect(() => {
    setActiveIndex({});
  }, [score]);

  return (
    <div className="colo">
      {!loading && (
        <>
          <div className="pl-20 pr-20">
            <div className="font16 fw600 color111 mt-80 text_center">
              {dsatFlag === '1' ? feedbackType.dsat.pageHeading : feedbackType.csat.pageHeading}
            </div>
            {/* <div className="font16 fw600 color111 pt-20 text_center">How would you rate your experience?</div> */}
            <div className="font13 fw400 color111 pt-20 text_center">
              Your support ticket (<span className="fw500">{results?.ticketId}</span>) was resolved by{' '}
              {results?.agentName ? <span className="fw500">{results.agentName}</span> : 'our support agent'}
            </div>

            <div
              className={`${style.ReviewImgBox}  ${imageText === 'Very Bad' ? style.VeryBad : style[imageText]} mt-30`}
            >
              {score && tags ? (
                <>
                  <div className={`${style.ReviewCircle}`}>
                    <img className={`${style.ReviewImage}`} src={image} alt="" />
                  </div>
                  <div className={`${style.ReviewImgText} ${style.Active} font14 fw400 colorFFF`}>{imageText}</div>
                </>
              ) : (
                <>
                  <img className={`${style.ReviewImage}`} src={image} alt="" />
                  <div className="font14 fw400 color111 mt-20">{imageText}</div>
                </>
              )}
            </div>
            <div className={`${style.Number} mt-50`}>
              <ul className={`${style.NumberList}`}>
                {color.flatMap((ele, i) =>
                  ele.num.split(',').map((num) => (
                    <button
                      className={`${style.NumberItem} ${parseInt(num, 10) <= score ? ratingColor : ''}`}
                      style={{
                        backgroundColor: parseInt(num, 10) > score || score === 0 ? ele.backgroundColor : '',
                        opacity: parseInt(num, 10) > score ? 0.35 : '',
                        color: '#fff',
                      }}
                      type="button"
                      onClick={async () => handleRatingClick(ele, num)}
                      key={`${i}-${num}`}
                    >
                      {num}
                    </button>
                  )),
                )}
              </ul>
              <div className={`${style.NumberNote} mt-15`}>
                <div className="font11 fw400 color777">Very dissatisfied</div>
                <div className="font11 fw400 color777">Very satisfied</div>
              </div>
            </div>
            <div className={`${style.Capsule} mt-40`}>
              <div className="font16 fw600 color111">{handleQuestions()}</div>
              <ul className={`${style.CapsuleList}`}>
                {score && tags
                  ? tags.map((tag, i) => (
                      <button
                        className={`${style.CapsuleItem}  ${activeIndex[i] ? style.Active : ''}`}
                        style={{ cursor: 'pointer' }}
                        type="button"
                        key={i}
                        onClick={() => handleTags(i, tag.id)}
                      >
                        <span className={`${style.CapsuleText} font12 fw400 pr-5`}>{tag.name}</span>
                        <span className={`${style.CapsuleIcon} csicon`} />
                      </button>
                    ))
                  : null}
              </ul>
            </div>
            {score ? (
              <>
                <div className={`${style.TextAreaBox} mt-40`}>
                  {dsatFlag === '1' ? feedbackType.dsat.reviewHeading : feedbackType.csat.reviewHeading}
                  <textarea
                    className={`${style.TextArea} font13 fw400 color111 mt-12`}
                    onChange={(e) => handleOnChange(e)}
                    maxLength={3000}
                  />
                  <div className={`${style.TextAreaNote} mt-10 mb-10`}>
                    <div className={`${style.TextError} font11 fw400 `}>
                      {!enableSubmitButton && comment.length > 3 ? '*Special characters not allowed' : ''}
                    </div>
                    <div
                      className={`${style.TextAreaCount}`}
                      style={{
                        marginBottom: '82px',
                      }}
                    >
                      <span className="font11 fw400 color777">{comment.length}</span>
                      <span className="font11 fw400 color111">/3000</span>
                    </div>
                  </div>
                </div>
              </>
            ) : null}

            <div className={`${style.ButtonGroup}`}>
              <button
                className={`${style.Button} ${
                  (score > 0 && comment.length === 0 && dsatFlag !== '1') ||
                  (score !== '' && comment.length > 3 && enableSubmitButton && dsatFlag !== '1') ||
                  (dsatFlag === '1' && score !== '' && handleFeedbackEnable())
                    ? ''
                    : style.Disabled
                } bluefill_animate font14 fw600 colorFFF`}
                type="button"
                onClick={() => {
                  if (
                    (score > 0 && comment.length === 0 && dsatFlag !== '1') ||
                    (score !== '' && comment.length > 3 && enableSubmitButton && dsatFlag !== '1') ||
                    (dsatFlag === '1' && score !== '' && handleFeedbackEnable())
                  )
                    submitFeedBack();
                }}
              >
                Submit Feedback
              </button>
            </div>
          </div>
        </>
      )}
      {dsatFlag === '1' && warningText && (
        <div className={`${style.Alert} font11 fw500 colorFFF`}>Rating once done can not be edited</div>
      )}
      {popupObj?.popupType === 'csRatingsCloseConfirmation' && <ConfirmationDialog />}
    </div>
  );
};
export default CSratings;
